import { BREAKPOINT_MEDIUM } from '@big-red-group/storefront-common-ui'
import styled from 'styled-components'

export const VoucherSelectorWrap = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 70%) minmax(0, 30%);
  gap: 60px;
  align-items: flex-start;

  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    grid-template-columns: 100%;
    gap: 20px;
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: flex-start;
  align-items: flex-start;
  border-radius: 4px;
  background-color: white;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 25px;
    left: -25px;
    position: relative;
    width: 100vw;
  }
`

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const DeliveryMethodWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`

export const DateWrapper = styled.div`
  z-index: 5;
  position: absolute;
  left: 50%;
  padding: 10px;
  transform: translate(-50%);
  background: white;
  border-radius: 4px;
`

export const CalendarWrapper = styled.div`
  position: relative;
`

export const BookingStepButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
`

export const DifferentMessages = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
`
